var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _g11, _g12, _path3, _path4, _path5, _path6, _path7, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardArtistBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1237 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.486 128.166C983.983 128.166 984.385 127.797 984.385 127.34C984.385 126.884 983.983 126.515 983.486 126.515C982.99 126.515 982.587 126.884 982.587 127.34C982.587 127.797 982.99 128.166 983.486 128.166Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.03 86.8764C1032.53 86.8764 1032.93 86.5067 1032.93 86.0506C1032.93 85.5945 1032.53 85.2248 1032.03 85.2248C1031.53 85.2248 1031.13 85.5945 1031.13 86.0506C1031.13 86.5067 1031.53 86.8764 1032.03 86.8764Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.555 89.3538C218.052 89.3538 218.454 88.984 218.454 88.528C218.454 88.0719 218.052 87.7022 217.555 87.7022C217.059 87.7022 216.656 88.0719 216.656 88.528C216.656 88.984 217.059 89.3538 217.555 89.3538Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.94 31.5485C1113.44 31.5485 1113.84 31.1787 1113.84 30.7227C1113.84 30.2666 1113.44 29.8969 1112.94 29.8969C1112.44 29.8969 1112.04 30.2666 1112.04 30.7227C1112.04 31.1787 1112.44 31.5485 1112.94 31.5485Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.753 198.358C572.249 198.358 572.652 197.989 572.652 197.533C572.652 197.077 572.249 196.707 571.753 196.707C571.256 196.707 570.854 197.077 570.854 197.533C570.854 197.989 571.256 198.358 571.753 198.358Z",
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0914 44.7609C97.5879 44.7609 97.9903 44.3912 97.9903 43.9352C97.9903 43.4791 97.5879 43.1094 97.0914 43.1094C96.5949 43.1094 96.1924 43.4791 96.1924 43.9352C96.1924 44.3912 96.5949 44.7609 97.0914 44.7609Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3838 74.4895C14.8803 74.4895 15.2828 74.1198 15.2828 73.6637C15.2828 73.2076 14.8803 72.8379 14.3838 72.8379C13.8874 72.8379 13.4849 73.2076 13.4849 73.6637C13.4849 74.1198 13.8874 74.4895 14.3838 74.4895Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.898982 7.60029C1.39548 7.60029 1.79796 7.23057 1.79796 6.77449C1.79796 6.31842 1.39548 5.9487 0.898982 5.9487C0.402488 5.9487 0 6.31842 0 6.77449C0 7.23057 0.402488 7.60029 0.898982 7.60029Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.707 70.3609C172.203 70.3609 172.606 69.9912 172.606 69.5351C172.606 69.0791 172.203 68.7093 171.707 68.7093C171.21 68.7093 170.808 69.0791 170.808 69.5351C170.808 69.9912 171.21 70.3609 171.707 70.3609Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.27 156.243C380.767 156.243 381.169 155.873 381.169 155.417C381.169 154.961 380.767 154.591 380.27 154.591C379.774 154.591 379.371 154.961 379.371 155.417C379.371 155.873 379.774 156.243 380.27 156.243Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter10_d_2860_12237)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.411 101.741C343.908 101.741 344.31 101.371 344.31 100.915C344.31 100.459 343.908 100.089 343.411 100.089C342.915 100.089 342.512 100.459 342.512 100.915C342.512 101.371 342.915 101.741 343.411 101.741Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter11_d_2860_12237)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.261 147.159C300.757 147.159 301.16 146.789 301.16 146.333C301.16 145.877 300.757 145.507 300.261 145.507C299.764 145.507 299.362 145.877 299.362 146.333C299.362 146.789 299.764 147.159 300.261 147.159Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.653 166.979C484.149 166.979 484.552 166.609 484.552 166.153C484.552 165.697 484.149 165.327 483.653 165.327C483.156 165.327 482.754 165.697 482.754 166.153C482.754 166.609 483.156 166.979 483.653 166.979Z",
    fill: "#D9D9D9"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.699 72.0121C884.196 72.0121 884.598 71.6424 884.598 71.1863C884.598 70.7303 884.196 70.3605 883.699 70.3605C883.203 70.3605 882.8 70.7303 882.8 71.1863C882.8 71.6424 883.203 72.0121 883.699 72.0121Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter14_d_2860_12237)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.502 127.341C440.999 127.341 441.401 126.971 441.401 126.515C441.401 126.059 440.999 125.689 440.502 125.689C440.006 125.689 439.603 126.059 439.603 126.515C439.603 126.971 440.006 127.341 440.502 127.341Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter15_d_2860_12237)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M416.229 21.6389C416.726 21.6389 417.128 21.2692 417.128 20.8131C417.128 20.3571 416.726 19.9874 416.229 19.9874C415.733 19.9874 415.33 20.3571 415.33 20.8131C415.33 21.2692 415.733 21.6389 416.229 21.6389Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter16_d_2860_12237)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M533.995 67.8836C534.492 67.8836 534.894 67.5138 534.894 67.0578C534.894 66.6017 534.492 66.232 533.995 66.232C533.499 66.232 533.096 66.6017 533.096 67.0578C533.096 67.5138 533.499 67.8836 533.995 67.8836Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter17_d_2860_12237)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M649.066 46.4127C649.563 46.4127 649.965 46.043 649.965 45.5869C649.965 45.1309 649.563 44.7611 649.066 44.7611C648.57 44.7611 648.167 45.1309 648.167 45.5869C648.167 46.043 648.57 46.4127 649.066 46.4127Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter18_d_2860_12237)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M805.489 32.374C805.985 32.374 806.388 32.0043 806.388 31.5483C806.388 31.0922 805.985 30.7225 805.489 30.7225C804.992 30.7225 804.59 31.0922 804.59 31.5483C804.59 32.0043 804.992 32.374 805.489 32.374Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.602 141.379C529.099 141.379 529.501 141.009 529.501 140.553C529.501 140.097 529.099 139.727 528.602 139.727C528.106 139.727 527.703 140.097 527.703 140.553C527.703 141.009 528.106 141.379 528.602 141.379Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.672 141.379C644.168 141.379 644.571 141.009 644.571 140.553C644.571 140.097 644.168 139.727 643.672 139.727C643.175 139.727 642.773 140.097 642.773 140.553C642.773 141.009 643.175 141.379 643.672 141.379Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.408 191.752C699.905 191.752 700.307 191.383 700.307 190.927C700.307 190.471 699.905 190.101 699.408 190.101C698.912 190.101 698.509 190.471 698.509 190.927C698.509 191.383 698.912 191.752 699.408 191.752Z",
    fill: "#D9D9D9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.356 119.909C922.852 119.909 923.255 119.539 923.255 119.083C923.255 118.627 922.852 118.257 922.356 118.257C921.859 118.257 921.457 118.627 921.457 119.083C921.457 119.539 921.859 119.909 922.356 119.909Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.1 20.8133C1236.6 20.8133 1237 20.4436 1237 19.9876C1237 19.5315 1236.6 19.1618 1236.1 19.1618C1235.6 19.1618 1235.2 19.5315 1235.2 19.9876C1235.2 20.4436 1235.6 20.8133 1236.1 20.8133Z",
    fill: "#D9D9D9"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.21 43.9353C1048.71 43.9353 1049.11 43.5656 1049.11 43.1095C1049.11 42.6535 1048.71 42.2838 1048.21 42.2838C1047.72 42.2838 1047.31 42.6535 1047.31 43.1095C1047.31 43.5656 1047.72 43.9353 1048.21 43.9353Z",
    fill: "#D9D9D9"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831.56 153.766C832.056 153.766 832.458 153.396 832.458 152.94C832.458 152.484 832.056 152.115 831.56 152.115C831.063 152.115 830.661 152.484 830.661 152.94C830.661 153.396 831.063 153.766 831.56 153.766Z",
    fill: "#D9D9D9"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.066 91.8317C649.563 91.8317 649.965 91.462 649.965 91.0059C649.965 90.5499 649.563 90.1801 649.066 90.1801C648.57 90.1801 648.167 90.5499 648.167 91.0059C648.167 91.462 648.57 91.8317 649.066 91.8317Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.296 88.5282C709.793 88.5282 710.195 88.1585 710.195 87.7024C710.195 87.2463 709.793 86.8766 709.296 86.8766C708.8 86.8766 708.397 87.2463 708.397 87.7024C708.397 88.1585 708.8 88.5282 709.296 88.5282Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804.59 94.3085C805.086 94.3085 805.489 93.9388 805.489 93.4827C805.489 93.0267 805.086 92.6569 804.59 92.6569C804.093 92.6569 803.691 93.0267 803.691 93.4827C803.691 93.9388 804.093 94.3085 804.59 94.3085Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.487 75.3695C541.966 75.3695 342.936 42.9892 296.691 71.5051V200.576H1237V5.46875C1201.76 -2.53579 1100.91 -16.4433 979.352 -8.03864C827.401 2.46705 793.01 75.3695 667.487 75.3695Z",
    fill: "url(#paint0_linear_2860_12237)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_2860_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.513 72.0126C695.034 72.0126 894.062 44.2492 940.309 68.6993V179.369H0V12.0779C35.2341 5.21454 136.092 -6.71031 257.649 0.496172C409.596 9.50399 443.991 72.0126 569.513 72.0126Z",
    fill: "url(#paint1_linear_2860_12237)",
    fillOpacity: 0.5
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9116 240.808C11.3642 215.02 8.50525 194.228 8.50525 194.228C8.50525 194.228 11.3642 215.033 14.9116 240.808ZM14.9116 240.808L21.3118 287.388",
    stroke: "url(#paint2_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7726 286.251L40.0703 240.808L27.368 195.366",
    stroke: "url(#paint3_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4376 197.275L65.2345 240.807L84.0253 284.373",
    stroke: "url(#paint4_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 281.786C114.972 281.786 103.998 263.483 90.392 240.807L65.8126 199.828",
    stroke: "url(#paint5_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5831 203.076L115.556 240.807L145.521 278.537",
    stroke: "url(#paint6_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.573 274.673L140.714 240.809L105.849 206.944",
    stroke: "url(#paint7_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.674 211.361L165.879 240.807L205.078 270.254",
    stroke: "url(#paint8_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.941 265.362L191.038 240.808L148.155 216.254",
    stroke: "url(#paint9_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.304 221.549L216.202 240.807L262.1 260.065",
    stroke: "url(#paint10_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.511 254.453L241.366 240.808L193.214 227.164",
    stroke: "url(#paint11_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.902 233.011L266.535 240.808L316.156 248.605",
    stroke: "url(#paint12_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.972 242.678L291.689 240.807L241.405 238.936",
    stroke: "url(#paint13_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.718 244.927L316.845 240.808L366.979 236.688",
    stroke: "url(#paint14_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.169 230.769L342.01 240.808L292.851 250.847",
    stroke: "url(#paint15_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.775 256.602L367.168 240.807L414.559 225.012",
    stroke: "url(#paint16_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.184 219.516L392.352 240.808L347.52 262.1",
    stroke: "url(#paint17_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.907 267.253L417.491 240.809L459.074 214.364",
    stroke: "url(#paint18_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.301 209.619L442.655 240.806L405.009 271.994",
    stroke: "url(#paint19_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.727 276.191L467.819 240.807C486.145 221.224 500.906 205.422 500.906 205.422",
    stroke: "url(#paint20_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.972 201.778L492.977 240.808L464.986 279.838",
    stroke: "url(#paint21_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.693 282.839L518.141 240.807L540.584 198.776",
    stroke: "url(#paint22_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.837 196.45C559.837 196.45 552.421 216.261 543.327 240.808L526.797 285.165",
    stroke: "url(#paint23_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.465 240.809C562.736 266.239 558.113 286.771 558.113 286.771C558.113 286.771 562.741 266.239 568.465 240.809ZM568.465 240.809C574.195 215.377 578.812 194.846 578.812 194.846C578.812 194.846 574.19 215.377 568.465 240.809Z",
    stroke: "url(#paint24_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.625 194.026C597.625 194.026 595.839 214.935 593.619 240.84C591.404 266.745 589.623 287.653 589.623 287.653C589.623 287.653 591.404 266.712 593.619 240.807C595.839 214.902 597.625 194.026 597.625 194.026Z",
    stroke: "url(#paint25_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.201 287.719C621.201 287.719 620.125 266.765 618.788 240.808C617.445 214.851 616.369 193.897 616.369 193.897",
    stroke: "url(#paint26_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.951 240.807C639.058 215.221 635.156 194.566 635.156 194.566C635.156 194.566 639.084 215.221 643.951 240.807ZM643.951 240.807L652.731 287.05",
    stroke: "url(#paint27_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.111 240.808C677.426 265.615 684.133 285.639 684.133 285.639C684.133 285.639 677.426 265.608 669.111 240.808ZM669.111 240.808L654.085 195.976",
    stroke: "url(#paint28_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.273 198.133C673.273 198.133 682.654 217.196 694.285 240.808L715.297 283.483L694.27 240.808C682.643 217.196 673.273 198.133 673.273 198.133Z",
    stroke: "url(#paint29_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.087 280.643C746.087 280.643 734.184 262.847 719.45 240.807L692.808 200.972L719.403 240.807C734.184 262.847 746.087 280.643 746.087 280.643Z",
    stroke: "url(#paint30_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.718 204.462L744.594 240.808L776.434 277.154",
    stroke: "url(#paint31_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.324 273.073L769.752 240.807L733.186 208.541",
    stroke: "url(#paint32_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.241 213.148L794.917 240.807L835.584 268.467",
    stroke: "url(#paint33_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.185 263.413L820.077 240.808L775.963 218.204",
    stroke: "url(#paint34_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.407 223.628L845.241 240.808L892.07 257.987",
    stroke: "url(#paint35_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.199 252.289L870.406 240.808L821.602 229.327",
    stroke: "url(#paint36_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.596 235.213L895.564 240.807L945.527 246.402",
    stroke: "url(#paint37_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.047 240.424L920.728 240.808L870.405 241.191",
    stroke: "url(#paint38_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.024 247.162L945.882 240.808L995.746 234.453",
    stroke: "url(#paint39_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.64 228.579L971.046 240.807L922.462 253.035",
    stroke: "url(#paint40_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.684 258.702L996.19 240.808L1042.72 222.914",
    stroke: "url(#paint41_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.06 217.534L1021.37 240.808L977.663 264.081",
    stroke: "url(#paint42_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.35 269.084L1046.53 240.808L1086.71 212.531",
    stroke: "url(#paint43_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.69 207.989L1071.69 240.807L1035.7 273.626",
    stroke: "url(#paint44_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.62 277.635L1096.86 240.807L1128.09 203.98",
    stroke: "url(#paint45_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.97 200.569L1122.02 240.808M1122.02 240.808C1107.65 263.074 1096.03 281.046 1096.03 281.046C1096.03 281.046 1107.62 263.074 1122.02 240.808Z",
    stroke: "url(#paint46_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.92 283.801C1126.92 283.801 1135.96 264.595 1147.18 240.808L1167.44 197.815",
    stroke: "url(#paint47_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.57 195.762L1172.33 240.808L1158.11 285.854",
    stroke: "url(#paint48_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.51 240.808C1193.09 266.466 1189.52 287.179 1189.52 287.179C1189.52 287.179 1193.07 266.466 1197.51 240.808ZM1197.51 240.808L1205.48 194.436",
    stroke: "url(#paint49_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.25 193.864C1224.25 193.864 1223.54 214.818 1222.66 240.808L1221.08 287.751",
    stroke: "url(#paint50_linear_2860_12237)",
    strokeWidth: 0.214414,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2860_12237",
    x: 978.991,
    y: 126.515,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2860_12237",
    x: 1027.54,
    y: 85.2248,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2860_12237",
    x: 213.06,
    y: 87.7022,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2860_12237",
    x: 1108.44,
    y: 29.8969,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2860_12237",
    x: 567.258,
    y: 196.707,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2860_12237",
    x: 92.5965,
    y: 43.1094,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2860_12237",
    x: 9.88894,
    y: 72.8379,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2860_12237",
    x: -3.59593,
    y: 5.9487,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_2860_12237",
    x: 167.212,
    y: 68.7093,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_2860_12237",
    x: 375.776,
    y: 154.591,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_2860_12237",
    x: 338.916,
    y: 100.089,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_2860_12237",
    x: 295.766,
    y: 145.507,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_2860_12237",
    x: 479.158,
    y: 165.327,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_2860_12237",
    x: 879.204,
    y: 70.3605,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_2860_12237",
    x: 436.007,
    y: 125.689,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_2860_12237",
    x: 411.734,
    y: 19.9874,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_2860_12237",
    x: 529.5,
    y: 66.232,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_2860_12237",
    x: 644.571,
    y: 44.7611,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_2860_12237",
    x: 800.994,
    y: 30.7225,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_2860_12237",
    x: 524.107,
    y: 139.727,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_2860_12237",
    x: 639.177,
    y: 139.727,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_2860_12237",
    x: 694.913,
    y: 190.101,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_2860_12237",
    x: 917.861,
    y: 118.257,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_2860_12237",
    x: 1231.61,
    y: 19.1618,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_2860_12237",
    x: 1043.72,
    y: 42.2838,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_2860_12237",
    x: 827.065,
    y: 152.115,
    width: 8.98983,
    height: 8.84344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_2860_12237",
    x: 644.571,
    y: 90.1801,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_2860_12237",
    x: 704.802,
    y: 86.8766,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_2860_12237",
    x: 800.095,
    y: 92.6569,
    width: 8.98983,
    height: 8.84343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79796
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2860_12237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2860_12237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_2860_12237",
    x: 213.948,
    y: -93.389,
    width: 1105.79,
    height: 376.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.3712,
    result: "effect1_foregroundBlur_2860_12237"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_2860_12237",
    x: -82.7425,
    y: -84.4824,
    width: 1105.79,
    height: 346.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.3712,
    result: "effect1_foregroundBlur_2860_12237"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2860_12237",
    x1: 363.795,
    y1: 118.779,
    x2: 1116.39,
    y2: 115.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2860_12237",
    x1: 1152.78,
    y1: 103.491,
    x2: -176.122,
    y2: 96.6724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C54FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2860_12237",
    x1: 4.94506,
    y1: 194.229,
    x2: 28.3926,
    y2: 194.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2860_12237",
    x1: 20.3049,
    y1: 195.366,
    x2: 66.8015,
    y2: 196.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2860_12237",
    x1: 35.9885,
    y1: 197.275,
    x2: 104.733,
    y2: 199.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2860_12237",
    x1: 52.1462,
    y1: 199.828,
    x2: 141.955,
    y2: 204.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2860_12237",
    x1: 68.9202,
    y1: 203.076,
    x2: 178.23,
    y2: 210.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2860_12237",
    x1: 86.4663,
    y1: 206.944,
    x2: 213.27,
    y2: 217.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2860_12237",
    x1: 104.878,
    y1: 211.361,
    x2: 246.818,
    y2: 226.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2860_12237",
    x1: 124.307,
    y1: 216.255,
    x2: 278.349,
    y2: 237.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2860_12237",
    x1: 144.785,
    y1: 221.549,
    x2: 306.914,
    y2: 252.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2860_12237",
    x1: 166.443,
    y1: 227.164,
    x2: 329.623,
    y2: 273.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2860_12237",
    x1: 189.309,
    y1: 233.011,
    x2: 333.293,
    y2: 306.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2860_12237",
    x1: 213.447,
    y1: 238.936,
    x2: 245.899,
    y2: 309.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2860_12237",
    x1: 238.845,
    y1: 236.688,
    x2: 332.573,
    y2: 328.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2860_12237",
    x1: 265.518,
    y1: 230.769,
    x2: 421.358,
    y2: 292.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2860_12237",
    x1: 293.425,
    y1: 225.012,
    x2: 457.43,
    y2: 264.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2860_12237",
    x1: 322.593,
    y1: 219.516,
    x2: 482.201,
    y2: 246.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2860_12237",
    x1: 352.787,
    y1: 214.364,
    x2: 502.676,
    y2: 233.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2860_12237",
    x1: 384.078,
    y1: 209.619,
    x2: 520.659,
    y2: 222.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2860_12237",
    x1: 416.33,
    y1: 205.422,
    x2: 536.824,
    y2: 214.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2860_12237",
    x1: 449.421,
    y1: 201.778,
    x2: 551.605,
    y2: 207.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2860_12237",
    x1: 483.215,
    y1: 198.776,
    x2: 565.263,
    y2: 202.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2860_12237",
    x1: 517.615,
    y1: 196.45,
    x2: 578.06,
    y2: 198.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2860_12237",
    x1: 552.358,
    y1: 194.846,
    x2: 590.25,
    y2: 195.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2860_12237",
    x1: 587.404,
    y1: 194.026,
    x2: 602.049,
    y2: 194.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2860_12237",
    x1: 615.022,
    y1: 193.897,
    x2: 623.875,
    y2: 193.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2860_12237",
    x1: 630.273,
    y1: 194.566,
    x2: 662.446,
    y2: 195.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2860_12237",
    x1: 645.733,
    y1: 195.976,
    x2: 700.711,
    y2: 197.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2860_12237",
    x1: 661.589,
    y1: 198.133,
    x2: 738.425,
    y2: 201.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2860_12237",
    x1: 678,
    y1: 200.972,
    x2: 775.278,
    y2: 206.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2860_12237",
    x1: 695.007,
    y1: 204.462,
    x2: 811.098,
    y2: 212.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2860_12237",
    x1: 712.853,
    y1: 208.541,
    x2: 845.679,
    y2: 220.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2860_12237",
    x1: 731.631,
    y1: 213.148,
    x2: 878.522,
    y2: 230.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2860_12237",
    x1: 751.441,
    y1: 218.204,
    x2: 909.097,
    y2: 242.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2860_12237",
    x1: 772.365,
    y1: 223.628,
    x2: 936.011,
    y2: 259.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2860_12237",
    x1: 794.469,
    y1: 229.327,
    x2: 954.469,
    y2: 284.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2860_12237",
    x1: 817.815,
    y1: 235.213,
    x2: 938.486,
    y2: 321.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2860_12237",
    x1: 842.425,
    y1: 240.424,
    x2: 844.06,
    y2: 257.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2860_12237",
    x1: 868.3,
    y1: 234.453,
    x2: 998.864,
    y2: 316.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2860_12237",
    x1: 895.444,
    y1: 228.579,
    x2: 1056.89,
    y2: 280.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2860_12237",
    x1: 923.82,
    y1: 222.914,
    x2: 1087.04,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2860_12237",
    x1: 953.366,
    y1: 217.534,
    x2: 1109.84,
    y2: 241.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2860_12237",
    x1: 984.015,
    y1: 212.531,
    x2: 1129.26,
    y2: 229.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2860_12237",
    x1: 1015.68,
    y1: 207.989,
    x2: 1146.49,
    y2: 219.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2860_12237",
    x1: 1048.26,
    y1: 203.981,
    x2: 1162.11,
    y2: 211.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2860_12237",
    x1: 1081.59,
    y1: 200.57,
    x2: 1176.45,
    y2: 205.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2860_12237",
    x1: 1115.66,
    y1: 197.815,
    x2: 1189.74,
    y2: 200.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2860_12237",
    x1: 1150.19,
    y1: 195.762,
    x2: 1202.27,
    y2: 197.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2860_12237",
    x1: 1185.09,
    y1: 194.436,
    x2: 1214.29,
    y2: 194.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2860_12237",
    x1: 1220.19,
    y1: 193.864,
    x2: 1226.01,
    y2: 193.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardArtistBg);
export default __webpack_public_path__ + "static/media/dashboardArtistBg.9950b0507cd8d987853fbb879301eee9.svg";
export { ForwardRef as ReactComponent };